export class OptionPhotoModel {
    title: string;
    positionCamera?: string;
    frameToUse?: string = 'frame_docs';
    imageFromGalery?: boolean = false;
    showPreviewImage?: boolean = true;
    backdropDismiss?: boolean = true;
}
